import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCss3, faHtml5, faJs, faNodeJs, faReact } from '@fortawesome/free-brands-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import Loader from 'react-loaders'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    return () => {
      clearTimeout(timer);
    }  
  });
  
  return(
    <>
      <div className='container about-page'>
        <div className='text-zone'>
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I have a deep passion for technology and programming, 
            constantly seeking new opportunities to expand my knowledge and skills,
            I approach challenges with a strategic mindset and adaptability.
          </p>
          <p>
            Graduating from the prestigious Makers Academy coding bootcamp has 
            instilled in me an unyielding 
            commitment to continuous growth and technical proficiency. 
          </p>
          <p>
            Beyond technical competence, my diverse professional journey has honed my 
            interpersonal, organizational, and creative problem-solving skills.
          </p>
        </div>

        <div className='stage-cube-cont'>
          <div className='cubespinner'>
            <div className='face1'>
              <FontAwesomeIcon icon={faHtml5} />
            </div>
            <div className='face2'>
              <FontAwesomeIcon icon={faReact} />
            </div>
            <div className='face3'>
              <FontAwesomeIcon icon={faNodeJs} />
            </div>
            <div className='face4'>
              <FontAwesomeIcon icon={faCss3} />
            </div>
            <div className='face5'>
              <FontAwesomeIcon icon={faJs} />
            </div>
            <div className='face6'>
              <FontAwesomeIcon icon={faDatabase} />
            </div>

          </div>

        </div>
      </div>
      <Loader type="pacman" />   
    </>
  )
};

export default About;